<template>
  <div :class="[type === 'popup' ? 'bodypadding' : '']">
    <div v-for="(item, index) in orderAddressList" :key="index" class="orderAddress-body-card">
      <div class="orderAddress-body-card-body" v-if="item.province">
        <div class="add-content">
          <div :class="['user', type === 'popup' ? 'maxWidth' : '']">
            <div class="user-div">
              <p class="user-name">{{ item.userName }}</p>
              <p class="user-phone">{{ item.phone }}</p>
            </div>
            <div class="local" v-if="item.addressDetail">
              {{ `${item.addressDetail}` }}
            </div>
            <div class="local" v-else>
              {{ `${item.province}${item.city}${item.area}${item.address}` }}
            </div>
          </div>
          <!-- 新增单选按钮 -->
          <van-radio-group v-model="index" v-if="type === 'popup'">
            <van-radio :name="index">
              <template #icon="">
                <img class="img-icon" :src="(index == currentIndex) ? activeIcon : inactiveIcon"
                  @click="onClickChangeAddress(index == currentIndex ? -1 : index, index, item)" />
              </template>
            </van-radio>
          </van-radio-group>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  props: {
    orderAddressList: Array,
    type: String
  },
  data() {
    return {
      currentIndex: -1, // 当前选中的历史地址
      activeIcon: require('@/assets/img/personalCenter/addcheck.png'),
      inactiveIcon: require('@/assets/img/personalCenter/nocheckact.png'),
    }
  },
  watch: {

  },
  methods: {
    onClickChangeAddress(num, index, item) {
      this.currentIndex = num;
      this.$emit('onClickChangeBgColor', num, index, item)
    },
  }
}
</script>

<style lang="scss" scoped>
.orderAddress-body {
  .maxWidth {
    width: 550px;
  }

  &-card {
    width: 100%;
    background-color: $bgWhite;
    border-radius: 12px;

    &-body {
      padding: 30px 36px 0 36px;

      .add-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 29px;
        border-bottom: 2px solid #f5f5f5;

        .user {
          &-div {
            display: flex;
            align-items: center;
          }

          &-name {
            color: #333;
            font-weight: 500;
            font-size: 25px;
            line-height: 36px;
          }

          &-phone {
            margin-left: 22px;
            color: #787878;
            font-weight: 400;
            font-size: 25px;
            line-height: 30px;
            line-height: 36px;
          }

          .img {
            width: 36px;
            height: 36px;
          }

          .local {
            max-width: 600px;
            margin-top: 11px;
            color: #333;
            font-weight: 400;
            font-size: 25px;
            line-height: 36px;
            @extend .ellipsis-2;
          }
        }

        .img {
          width: 36px;
          height: 36px;
        }
      }

      .img-icon {
        width: 36px;
        height: 36px;
      }
    }
  }

  &-card:last-child .add-content {
    border: none;
  }

  .bodypadding {
    padding-bottom: 180px;
  }
}
</style>
